import { GivelifyPaper } from '@givelify/ui';
import { styled } from '@mui/material';
import Logo from '../../components/Logo';

export const Wrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
        height: '100vh',
    },
    [theme.breakpoints.down('mobile')]: {
        margin: '24px 16px',
    },
}));

export const Paper = styled(GivelifyPaper)(({ theme }) => ({
    padding: '24px 40px',
    width: 450,
    [theme.breakpoints.down('mobile')]: {
        width: '100%',
    },
}));

export const GivelifyLogo = styled(Logo)(({ theme }) => ({
    width: '100%',
    marginBottom: 64,
    [theme.breakpoints.down('mobile')]: {
        marginBottom: 48,
    },
}));

export const Labels = styled('div')(({ theme }) => ({
    marginBottom: 24,
    [theme.breakpoints.down('mobile')]: {
        marginBottom: 16,
    },
}));

export const SubmitButtonWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    marginTop: 24,
    [theme.breakpoints.down('mobile')]: {
        marginTop: 16,
    },
}));

export const CheckboxWrapper = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
}));

export const TextFieldWrapper = styled('div')(() => ({
    marginBottom: 12,
}));